export default __webpack_public_path__ + "20513bb50ed30031a817cee23e2e662d.png";